export { default } from "./useEventProperties";
